import cn from 'classnames';
import { useLayoutEffect, useRef } from 'react';

import s from './Clock.module.css';

const Clock = ({ className, minutes }: { className?: string; minutes: number }) => {
  const clockRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (clockRef.current) {
      clockRef.current.style.setProperty('--end', minutes * 6 + 'deg');
    }
  }, [minutes]);

  return <div ref={clockRef} className={cn(s.clock, className)} />;
};

export { Clock };
